import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { store } from "@/state/store";
import { pushEvent } from "@/services/dataLayerLogin";
import SharedButton from "@SharedVueComponents/SharedButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleLogin',
  setup(__props) {

function googleLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=google`;
	pushEvent("GoogleButton");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SharedButton, {
    variant: "secondary",
    "append-icon": "social-google",
    "icon-prefix": false,
    "aria-label": "Google Anmeldung",
    onClick: googleLogin
  }))
}
}

})